import { useEffect } from 'react';

/**
 * Keyboard shortcuts:
 * R - Pochtani tekshirish (refresh)
 * N - Keyingi tab ga o'tish
 * P - Oldingi tab ga o'tish
 * E - Emails tab
 * D - Dashboard tab
 * S - Send tab
 * A - Admin tab
 * Esc - Ortga (email detail dan chiqish)
 * / - Qidirish (focus)
 */
const KeyboardShortcuts = ({ activeTab, onTabChange, onBack, onRefresh }) => {
  useEffect(() => {
    const tabs = ['dashboard', 'emails', 'mappings', 'send', 'admin'];

    const handleKeyDown = (e) => {
      // Input yoki textarea da bo'lsa — ishlamasin
      const tag = e.target.tagName.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return;

      switch (e.key.toLowerCase()) {
        case 'r':
          e.preventDefault();
          if (onRefresh) onRefresh();
          break;
        case 'n':
          e.preventDefault();
          const nextIdx = (tabs.indexOf(activeTab) + 1) % tabs.length;
          onTabChange(tabs[nextIdx]);
          break;
        case 'p':
          e.preventDefault();
          const prevIdx = (tabs.indexOf(activeTab) - 1 + tabs.length) % tabs.length;
          onTabChange(tabs[prevIdx]);
          break;
        case 'e':
          e.preventDefault();
          onTabChange('emails');
          break;
        case 'd':
          e.preventDefault();
          onTabChange('dashboard');
          break;
        case 's':
          e.preventDefault();
          onTabChange('send');
          break;
        case 'a':
          e.preventDefault();
          onTabChange('admin');
          break;
        case 'escape':
          if (onBack) onBack();
          break;
        case '/':
          e.preventDefault();
          const searchInput = document.querySelector('input[type="text"]');
          if (searchInput) searchInput.focus();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeTab, onTabChange, onBack, onRefresh]);

  return null;
};

export default KeyboardShortcuts;
